import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from "@angular/forms";
import { InvoicesService } from '../../../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../../../_helpers/index';
import { ParameterData } from '../../../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../_helpers/dataservice.service'
import { CustomerService } from '../../../_services/customer.service'
import { DebtorService } from '../../../_services/debtor.service'
import { Invoice, PaymentProcess, Debtor, InvoiceList, Account, Notification, Recipient } from '../../../_models';
import { NotificationService } from '../../../_services/notification.service'
import { DatePipe, DecimalPipe } from '@angular/common';
import { PaymentProcessService } from '../../../_services/paymentprocess.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ConfirmationDialogService } from '../../../_services/confirmdialog.service';
import * as moment from 'moment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AuthService, CommonDataService, PayoutService, UserService } from '../../../_services';
import { NotificationReportStatus } from '../../../_enums';
import { Activity } from 'src/app/_models/activity.interface';
import { InvoicePaymentType } from '../../../_enums/invoice-payment-type.enums';
import { PayoutAccountType } from '../../../sharedcomp/constans/payoutAccountType.constans';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css', '../../../../assets/css/customer-list-table.css']
})
export class PayoutInvoiceViewComponent implements OnInit {

    public customer_public_id: string;
    public customer_account_public_id: string;

    public applicationTitle: any;

    public gmtZeroID = false;
    public gmtNonZeroID = false;

    public gmtExpZeroID = false;
    public gmtExpNonZeroID = false;

    htmlEditorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '25rem',
        minHeight: '5rem',
        placeholder: 'Texto aqui...',
        translate: 'no',
        uploadUrl: 'v1/images', // if needed
        customClasses: [ // optional
            {
                name: "quote",
                class: "quote",
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: "titleText",
                class: "titleText",
                tag: "h1",
            },
        ]
    };

    notificationDetailEditorConfig: AngularEditorConfig = {
        editable: false,
        spellcheck: true,
        height: '25rem',
        minHeight: '5rem',
        placeholder: 'Texto aqui...',
        translate: 'no',
        uploadUrl: 'v1/images', // if needed
        enableToolbar: false,
        showToolbar: false,
        customClasses: [ // optional
            {
                name: "quote",
                class: "quote",
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: "titleText",
                class: "titleText",
                tag: "h1",
            },
        ]
    };


    excelExportData: any;
    invoicePublic_key;
    scheduleDate: any;

    //////////
    titleName: string;
    name: string;
    description: string;
    clientname: string;
    client_public_id: string;
    status: string;
    client: string;
    late_fee: string;
    fees: string;
    sub_total: string;
    total: string;
    created: string;
    due_datetime: string;
    expiration_datetime: string;
    totalcurrency: string;
    invoicepublic_id: string;
    invoicetotalvalue: string;
    references: string;
    idClient: string;
    debtorpublic_id: string
    invoiceidtitle: string;

    late_fee_symbol: string;
    fees_symbol: string;
    sub_total_symbol: string;
    total_symbol: string;

    ////////
    debtorData: Debtor;
    debtorName: string;
    debtorPublicId: string;
    debtoremail: string;
    debtorPhone: string;
    debtordocumenttype: string;
    debtordocumentid: string;
    customerPublicId: string;

    pageSize: number;
    PageSizeOptions: number[];

    public paymentprocessForm: FormGroup;
    public notificationForm: FormGroup;
    public notificationEditForm: FormGroup;

    public cusPsp_accountsList: Account[] = [];
    public cusDebtorAccountsList: Account[] = [];

    public invoicelist_temp: InvoiceList[] = [];
    public invoice_temp: Invoice;
    public InvoiceNotifyTemplateList: any;
    public custNotifyTemplateList: any;
    public indNotificationTemplateDetail: any;

    mdlNotificationInvoiceBody: any;

    tmpInvoiceDetails: any;
    tmpDebtorDetails: any;

    //historical table related variables and properties
    invHistoricalListDataSource: Activity[];
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatPaginator) paginatorHistorical: MatPaginator;

    @ViewChild('closeAddExpenseModal') closeAddExpenseModal: ElementRef;
    displayedColumns: string[] = ['created', 'description', 'name', 'username'];
    minDate = new Date();
    //Notification table related variables and properties
    invNotificationListDataSource;
    displayedNotifyColumns: string[] = ['type', 'created', 'header', 'username', 'name', 'status', 'actions'];

    individualNotificationDetails: any;
    notTitle: any;
    notUserName: any;
    notReceiveEmail: any;
    notContent: any;
    notCreated: any;
    notStatus: any;
    notSender: any;
    notRecipients: any;
    notType: any;
    public user_public_id: string;
    paymentDetail: any;
    pspAccountName: any;
    notContentControl = new FormControl()
    notScheduled: any;
    notScheduledDate: any;
    accountNumber: any;
    bankId: any;
    bankName: any;
    isUpdateAvailable = true;
    isDeleteAvailable = true;
    isRejectAvailable = true;
    invoiceKtin: any;
    paymentMethod: any;
    kashioApplication: any;
    paymentCodeConfiguration: any;
    isPaymentCodeConfiguration = false;
    invoiceRejectForm: FormGroup;
    userDetails: any;
    userRole: any;
    userRoleStatus: any;
    cci: string;
    currency: string;
    accountType: string;
    notificationProperties: any;
    notificationPropertiesLabelName = "";
    notificationPropertiesDictionary = null;

    templateListLimit: number = 100;
    /** This is Constructor function which is used to initialize the class variables and objects;
    */
    constructor
        (
            private router: Router
            , private formBuilder: FormBuilder
            , private excelService: ExcelService
            , private parameterData: ParameterData
            , private dataService: DataService
            , private invoicesService: InvoicesService
            , private readonly activatedRoute: ActivatedRoute
            , private paymentProcessService: PaymentProcessService
            , private _fbpayprocess: FormBuilder
            , private customerService: CustomerService
            , private debtorService: DebtorService
            , private notificatioService: NotificationService
            , private _fbnotification: FormBuilder
            , private datePipe: DatePipe
            , private decimalPipe: DecimalPipe
            , private confirmationDialogService: ConfirmationDialogService
            , private spinnerService: Ng4LoadingSpinnerService
            , private auth: AuthService
            , private _fb: FormBuilder
            , private payoutService: PayoutService
            , private userService: UserService
            , private commonDataService: CommonDataService
            , private notificationReportStatus: NotificationReportStatus

        ) {
        this.spinnerService.show();
        this.commonDataService.getNotificationPropertiesSharedData().subscribe(data => this.notificationProperties = data);

        this.InitialSetup();
        this.InitialSetup_Notification();
        this.scheduleDate = new Date();
    }//end


    /** This function is used to initialize form controls;
     */
    InitialSetup() {

        this.paymentprocessForm = this._fbpayprocess.group({
            is_confirmed: new FormControl(""),
            reference: new FormControl(""),
            external_id: new FormControl(""),
            public_id: new FormControl(""),
            status: new FormControl(""),
            created: new FormControl(new Date()),

            debtor: this._fbpayprocess.group({
                public_id: new FormControl("Seleccione")
            }),

            user: this._fbpayprocess.group({
                public_id: ""
            }),

            psp_operation: this._fbpayprocess.group({
                external_id: new FormControl(""),
                channel: new FormControl("WEB"),
                method: new FormControl("CASH"),
                processing_date: new FormControl(new Date()),
                description: new FormControl(""),
                name: new FormControl(""),
                public_id: new FormControl(""),
                customer_account: this._fbpayprocess.group({
                    public_id: new FormControl("Seleccione")
                }),
                psp_account: this._fbpayprocess.group({
                    public_id: new FormControl("")
                }),
                total: this._fbpayprocess.group({
                    currency: new FormControl(""),
                    value: new FormControl("")
                })
            }),
            invoice_list: this._fbpayprocess.array([
                ({
                    id: [""],
                    public_id: [""],
                    late_fee: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    sub_total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    })
                })
            ])
        });

        //invoice reject Form
        this.invoiceRejectForm = this._fb.group({
            description: new FormControl('', [Validators.required]),
        })


    }//end initial setup

    InitialSetup_Notification() {
        this.notificationForm = this._fbnotification.group({
            templatenames: new FormControl(""),
            NotificationFor: new FormControl(""),
            NotificationAffair: new FormControl(""),

            customer: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            header: new FormControl(""),
            name: new FormControl(""),
            scheduled: new FormControl(""),
            recipients: this._fbnotification.group({
                name: new FormControl(""),
                email: new FormControl("")
            }),

            user: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            object_related_public_id: new FormControl(""),
            content: new FormControl("")


        });

        var currentDueDate = new Date();
        this.notificationEditForm = this._fbnotification.group({
            templatenames: new FormControl(""),
            NotificationFor: new FormControl(""),
            NotificationAffair: new FormControl(""),

            customer: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            header: new FormControl(""),
            name: new FormControl(""),
            scheduled: new FormControl(new Date(currentDueDate)),
            recipients: this._fbnotification.group({
                name: new FormControl(""),
                email: new FormControl("")
            }),

            user: this._fbnotification.group({
                public_id: new FormControl("")
            }),

            object_related_public_id: new FormControl(""),
            content: new FormControl("")

        });
    }//end


    /** This is ngOnInit function called after initialising the component;
     */
    ngOnInit() {
        window.scroll(0, 0);
        this.checkThisPageGrants();
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            let browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');

            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }

        this.kashioApplication = localStorage.getItem('application')
        this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
        this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

        //  }
        this.getNotificationProperties();
        this.applicationTitle = AppConfig.settings.applicationSetting.title;
        this.paymentprocessForm.get('psp_operation.method').setValue('EFECTIVO');

        //this is used to get the customer psp account list; because we need to send the customer psp account public key to core api
        //so we will get top 1 public id from this list
        if (this.kashioApplication == "PAYMENTS") {
            this.checkPaymentCodeConfiguration();
        }
        //this.getpsp_account_publicId();

        this.getCustomerNotificationTemplateList("");


        //used to retrieve the customer public id
        let params: any = this.activatedRoute.snapshot.params;
        this.invoicePublic_key = params.id;

        this.GetIndividualInvoiceDetails();
        this.getInvoiceNotificationList();

    }//end

    /**
     * this function is used to get Customer Notification Template List.
     */
    getInvoiceNotificationList() {
        this.spinnerService.show();
        this.invoicesService.getInvoiceNotificationList(this.invoicePublic_key)
            .subscribe(data => {
                let resources = data["data"];
                this.invNotificationListDataSource = resources;
                this.spinnerService.hide();
            }, error => {
                console.error('Failed while trying to getInvoiceNotificationList ' + error);
                this.spinnerService.hide();
            });
    }//end

    executeViewInvoiceNotDetails(event) {
        this.viewInvoiceNotDetails(event);
    }

    viewInvoiceNotDetails(element) {
        this.spinnerService.show();
        this.notificatioService.getNotification(element)
            .subscribe(data => {
                let resources = data;
                this.individualNotificationDetails = resources;
                this.notTitle = this.individualNotificationDetails.header;
                this.notUserName = this.individualNotificationDetails.user.name;
                this.notReceiveEmail = this.individualNotificationDetails.recipients[0].email;
                this.notContent = this.individualNotificationDetails.content;
                this.notCreated = this.individualNotificationDetails.created;
                this.notStatus = this.individualNotificationDetails.status;
                this.notSender = this.individualNotificationDetails.sender;
                this.notContentControl.setValue(this.notContent);
                this.notType = this.individualNotificationDetails.type;
                if (this.notType == 'WHATSAPP' || this.notType == 'SMS') {
                    this.notRecipients = this.individualNotificationDetails.recipients[0].phone;
                }
                if (this.notType == 'EMAIL') {
                    this.notRecipients = this.individualNotificationDetails.recipients[0].email;
                }
                if (this.notType == 'WEBHOOK') {
                    this.notRecipients = this.individualNotificationDetails.recipients[0].webhook;
                }
                if (this.notStatus == 'SCHEDULED') {
                    this.notScheduledDate = this.individualNotificationDetails.scheduled
                }

                this.spinnerService.hide();
            });
    }

    /**
     * this function is used to get Customer Notification Template List.
     */
    getCustomerNotificationTemplateList(public_id: string) {
        this.customerService.getCustomerNotificationTemplateList(this.customer_public_id, this.templateListLimit)
            .subscribe(data => {
                if (data && Array.isArray(data)) {
                    this.custNotifyTemplateList = data.filter(item => item.status == 'ACTIVE' && item.type == 'EMAIL');

                    if (this.custNotifyTemplateList && this.custNotifyTemplateList.length > 0) {
                        this.notificationForm.controls.templatenames.setValue(this.custNotifyTemplateList[0].public_id);
                        this.getNotificationTempDetails(this.custNotifyTemplateList[0].public_id);
                    }
                } else {
                    this.custNotifyTemplateList = [];
                }
            }, error => {
                this.custNotifyTemplateList = [];
            });
    }//end

    checkResponse() {
        const timerId = setTimeout(() => {
            if (this.debtorData != undefined && this.tmpInvoiceDetails != undefined && this.userDetails.customer.name != undefined) {
                clearTimeout(timerId);
                this.notificationForm.controls.header.setValue(this.replaceTemplateHeader(this.indNotificationTemplateDetail.header));
                this.notificationForm.controls.name.setValue(this.debtoremail);
                this.notificationForm.controls.content.setValue(this.replaceTemplateConstant(this.indNotificationTemplateDetail.content));
                this.spinnerService.hide();
            } else {
                this.checkResponse();
            }
        }, 100);
    }

    /** This function is used to get the Notification Temp Details;
     * it accepts the param select status value
     */
    getNotificationTempDetails(publicId) {
        this.spinnerService.show();
            if (publicId !== 0) {
                this.customerService.getIndNotificationTemplateDetail(publicId)
                    .subscribe(data => {
                        this.indNotificationTemplateDetail = data;
                        if (this.indNotificationTemplateDetail !== undefined || this.indNotificationTemplateDetail !== null) {
                            this.checkResponse();
                        } else {
                            this.spinnerService.hide();
                            return "";
                        }
                    });
            } else {
                this.spinnerService.hide();
                return "";
            }
    }//end

    public options: Object = {
        charCounterCount: true,
        toolbarButtons: ['bold', 'italic', 'underline', 'paragraphFormat'],
        toolbarButtonsXS: ['bold', 'italic', 'underline', 'paragraphFormat'],
        toolbarButtonsSM: ['bold', 'italic', 'underline', 'paragraphFormat'],
        toolbarButtonsMD: ['bold', 'italic', 'underline', 'paragraphFormat'],
    };

    /** This function is used to replace the Notification Template constant {{}} values;
     * it accepts the param value
     */
    replaceTemplateHeader(value: string) {
        value = value.replace(/{{cliente.id}}/gi, this.idClient);
        value = value.replace(/{{cliente.nombre}}/gi, this.debtorName);
        value = value.replace(/{{cliente.email}}/gi, this.debtoremail);
        value = value.replace(/{{cliente.telefono}}/gi, this.debtorPhone);
        value = value.replace(/{{cliente.tipo_documento}}/gi, this.debtordocumenttype);
        value = value.replace(/{{cliente.numero_documento}}/gi, this.debtordocumentid);
        value = value.replace(/{{orden.fecha}}/gi, moment(this.tmpInvoiceDetails.created).format('DD/MM/YYYY'));

        value = value.replace(/{{orden.referencia}}/gi, this.tmpInvoiceDetails.metadata.order_id);

        value = value.replace(/{{orden.nombre}}/gi, this.tmpInvoiceDetails.name);

        value = value.replace(/{{orden.moneda}}/gi, this.tmpInvoiceDetails.total.symbol);
        value = value.replace(/{{orden.monto}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.total.value, '1.2-2', 'en-US'));


        value = value.replace(/{{orden.fechavencimiento}}/gi, (this.tmpInvoiceDetails.due_datetime == 'none' || this.tmpInvoiceDetails.due_datetime == 'None' || this.tmpInvoiceDetails.due_datetime == undefined) ? '' : moment(this.tmpInvoiceDetails.due_datetime).format('DD/MM/YYYY'));
        value = value.replace(/{{orden.fechaexpiracion}}/gi, (this.tmpInvoiceDetails.expiration_datetime == 'none' || this.tmpInvoiceDetails.expiration_datetime == 'None' || this.tmpInvoiceDetails.expiration_datetime == undefined) ? '' : moment(this.tmpInvoiceDetails.expiration_datetime).format('DD/MM/YYYY'));


        value = value.replace(/{{orden.subtotal}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.sub_total.value, '1.2-2', 'en-US'));
        value = value.replace(/{{orden.mora}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.late_fee.value, '1.2-2', 'en-US'));
        value = value.replace(/{{Orden.Descripcion}}/gi, this.tmpInvoiceDetails.metadata.order_description);

        value = value.replace(/{{orden.descripcion}}/gi, this.tmpInvoiceDetails.metadata.order_description);

        value = value.replace(/{{usuario.nombre}}/gi, localStorage.getItem('username'));
        value = value.replace(/{{usuario.email}}/gi, localStorage.getItem('userEmail'));
        value = value.replace(/{{empresa.nombre}}/gi, this.userDetails.customer.name);

        return value;
    }

    replaceTemplateConstant(value: string) {
        value = value.replace(/{{cliente.id}}/gi, this.idClient);
        value = value.replace(/{{cliente.nombre}}/gi, this.debtorName);
        value = value.replace(/{{cliente.email}}/gi, this.debtoremail);
        value = value.replace(/{{cliente.telefono}}/gi, this.debtorPhone);
        value = value.replace(/{{cliente.tipo_documento}}/gi, this.debtordocumenttype);
        value = value.replace(/{{cliente.numero_documento}}/gi, this.debtordocumentid);

        value = value.replace(/{{orden.fecha}}/gi, moment(this.tmpInvoiceDetails.created).format('DD/MM/YYYY'));
        value = value.replace(/{{orden.referencia}}/gi, this.tmpInvoiceDetails.metadata.order_id);
        value = value.replace(/{{orden.codigo_pago}}/gi, this.tmpInvoiceDetails.ktin);
        value = value.replace(/{{orden.nombre}}/gi, this.tmpInvoiceDetails.name);

        value = value.replace(/{{orden.moneda}}/gi, this.tmpInvoiceDetails.total.symbol);
        value = value.replace(/{{orden.monto}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.total.value, '1.2-2', 'en-US'));


        value = value.replace(/{{orden.fechavencimiento}}/gi, (this.tmpInvoiceDetails.due_datetime == 'none' || this.tmpInvoiceDetails.due_datetime == 'None' || this.tmpInvoiceDetails.due_datetime == undefined) ? '' : moment(this.tmpInvoiceDetails.due_datetime).format('DD/MM/YYYY'));
        value = value.replace(/{{orden.fechaexpiracion}}/gi, (this.tmpInvoiceDetails.expiration_datetime == 'none' || this.tmpInvoiceDetails.expiration_datetime == 'None' || this.tmpInvoiceDetails.expiration_datetime == undefined) ? '' : moment(this.tmpInvoiceDetails.expiration_datetime).format('DD/MM/YYYY'));


        value = value.replace(/{{orden.subtotal}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.sub_total.value, '1.2-2', 'en-US'));
        value = value.replace(/{{orden.mora}}/gi, this.decimalPipe.transform(this.tmpInvoiceDetails.late_fee.value, '1.2-2', 'en-US'));
        value = value.replace(/{{Orden.Descripcion}}/gi, this.tmpInvoiceDetails.metadata.order_description);

        value = value.replace(/{{orden.descripcion}}/gi, this.tmpInvoiceDetails.metadata.order_description);

        value = value.replace(/{{usuario.nombre}}/gi, localStorage.getItem('username'));
        value = value.replace(/{{usuario.email}}/gi, localStorage.getItem('userEmail'));
        let gateWayURL = "<a href=" + this.tmpInvoiceDetails.gateway_url + " target=_blank>" + this.tmpInvoiceDetails.gateway_url + "</a>";
        value = value.replace(/{{orden.link}}/gi, gateWayURL);
        value = value.replace(/{{orden.fees}}/gi, (this.tmpInvoiceDetails.fees == undefined || this.tmpInvoiceDetails.fees.value == undefined) ? '' : this.tmpInvoiceDetails.fees.value);
        value = value.replace(/{{empresa.nombre}}/gi, this.userDetails.customer.name);
        return value;
    }//end

    /**
     * this function is used to get the individual invoice details.
     * @param publicId is send to invoice service and recieives the data as Invoice
     */
    GetIndividualInvoiceDetails() {
        this.invoicesService.getInvoice(this.invoicePublic_key).subscribe((data: Invoice) => {

            this.tmpInvoiceDetails = data;
            this.titleName = data.name;
            this.name = data.name;
            this.invoiceidtitle = data.invoice_id;
            this.description = data.metadata.order_description;
            this.status = data.status;
            this.client = data.debtor.name;
            this.references = data.metadata.order_id;
            this.idClient = data.metadata.client_id == undefined ? '' : data.metadata.client_id;
            this.client_public_id = data.debtor.public_id;
            this.GetIndividualDebtorDetails();
            this.clientname = data.debtor.name;
            this.late_fee = data.late_fee.value.toString();
            this.fees = data.fees.value.toString();
            this.sub_total = data.sub_total.value.toString();
            this.total = data.total.value.toString();
            this.late_fee_symbol = data.late_fee.symbol;
            this.fees_symbol = data.late_fee.symbol;
            this.sub_total_symbol = data.sub_total.symbol;
            this.total_symbol = data.total.symbol;
            this.created = data.created;

            this.due_datetime = data.due_datetime;
            this.expiration_datetime = data.expiration_datetime;
            this.totalcurrency = data.total.currency;
            this.invoicepublic_id = data.public_id;
            this.invoicetotalvalue = data.total.value.toString();
            this.debtorpublic_id = data.debtor.public_id;
            this.invHistoricalListDataSource = data.activity_list;
            this.paymentMethod = data.metadata.payment_method == undefined ? "" : data.metadata.payment_method;

            if (this.kashioApplication == "PAYOUTS") {
                this.payoutApplicationInvoiceView(data);
            }

            this.spinnerService.hide();
        },
            error => {
                this.spinnerService.hide();
                console.error('Failed while trying to get Indvidual Invoice Detail. ' + error);
            });
    }

    setAccountType(account: string) {
      return PayoutAccountType[account] || account;
    }

    payoutApplicationInvoiceView(data) {
        this.accountNumber = data.metadata.payout.account.account_number;
        this.bankName = data.metadata.payout.account.bank.name;
        this.currency = data.metadata.payout.account.balance.currency;
        if (data.metadata.metadata !== undefined) {
            this.cci = data.metadata.metadata.accounts[0].cci;
            this.accountType = this.setAccountType(data.metadata.metadata.accounts[0].type);
        }
    }

    /**
     * this function is used to get the individual debtor details.
     * @param publicId is send to debtor service and recieives the data as Debtor
     */
    GetIndividualDebtorDetails() {
        this.debtorService.getDebtor(this.client_public_id).subscribe((data: Debtor) => {
            this.debtorData = data;
            this.debtorName = data.name;
            this.debtorPublicId = data.public_id;
            this.debtoremail = data.email;
            this.debtorPhone = data.phone;
            this.debtordocumenttype = data.document_type;
            this.debtordocumentid = data.document_id;
            this.customerPublicId = data.creditor.public_id;
        },
            error => {
                console.error('Failed while trying to get Indvidual Debtor Detail. ' + error);
            });
    }//end

    /**
     * this function is used to get the individual invoice details.
     * @param publicId is send to invoice service and recieives the data as Invoice
     */
    onsubmitPaymentProcess({ value }: { value: PaymentProcess }) {
        let invarr: Invoice[] = [{ "public_id": this.invoicepublic_id, "total": { "currency": this.totalcurrency, "value": Number(this.invoicetotalvalue), "symbol": "" } }];
        value.invoice_list = invarr

        value.psp_operation.method = "CASH";
        value.psp_operation.total.currency = this.totalcurrency;
        value.psp_operation.total.value = Number(this.total);
        value.psp_operation.customer_account.public_id = this.customer_account_public_id;

        value.debtor.public_id = this.client_public_id;
        value.debtor.name = this.clientname;

        if (value.is_confirmed == true) {
            value.is_confirmed = true;
        }
        else {
            value.is_confirmed = false;
        }
        this.paymentProcessService.createPayment(value)
            .subscribe((result) => {

            }, error => {
                console.error('Failed while trying to update the payments Details.' + error);
            });
    }

    /**
   * this function is used to get the individual invoice details.
   * @param public Id is send to invoice service and recieives the data as Invoice
   */
    onsubmitNotificationForm({ value }: { value: Notification }) {

        value.customer.public_id = this.customerPublicId;

        let recipientarr: Recipient[] = [{ "name": '', "email": value.name }];

        value.user.public_id = localStorage.getItem("userId");

        value.object_related_public_id = this.invoicepublic_id;
        value.sender = localStorage.getItem("userEmail");
        value.recipients = recipientarr;


        this.confirmationDialogService.confirm(this.applicationTitle, value.name)
            .then(valueconfirm => {
                //this return will `return` value in chained manner

                if (valueconfirm == true) {

                    this.notificatioService.createNotification(value)
                        .subscribe((result) => {
                            if (result.status == "201" || result.status == "400") {
                                this.getInvoiceNotificationList();
                                this.closeAddExpenseModal.nativeElement.click();
                            }

                        }, error => {
                            this.router.navigate([`/payout/invoices/${this.invoicePublic_key}/view`]);
                            console.error('Failed while trying to save the Notification Template Details.' + error);
                        });
                }
                else {
                    this.closeAddExpenseModal.nativeElement.click();
                }

            },
                error => {
                    this.closeAddExpenseModal.nativeElement.click();
                });
    }

    /**
     * this function is used to get the cancel the Invoice Details .
     */
    onConfirmInvoice() {

        this.invoicesService.deleteInvoice(this.invoicePublic_key)
            .subscribe((result) => {
                this.router.navigate(['/payout/invoices']);
            }, error => {
                console.error('Failed while trying to cancel the invoice Details.' + error);
            });
    }

    executeInvoiceGridActionClick(event: string[]) {
        const [type, id] = event;
        this.invoicegridActionClick(type, id);
    }

    /**
    * this function is used to redirect to the right component based on input.
    */
    invoicegridActionClick(viewtype, publicid) {
        if (viewtype === 'notificationedit') {
            this.getIndNotificationDetails(publicid);
        } else if (viewtype === 'notificationdelete') {
            this.onConfirmNotificationDelete(publicid);
        };
    }

    /**
  * this function is used to get the cancel the Notification Details .
  */
    onConfirmNotificationDelete(publicid) {
        let StatusValue = { "status": "VOIDED" };
        this.notificatioService.updateNotification(publicid, StatusValue)
            .subscribe((result) => {
                this.getInvoiceNotificationList();

            }, error => {
                console.error('Failed while trying to cancel the Notification Details.' + error);
            });
    }

    /** This function is used to get the Notification Temp Details;
     * it accepts the param select status value
     **/
    getIndNotificationDetails(publicId) {
        setTimeout(() => {
            this.notificatioService.getNotification(publicId)
                .subscribe(data => {

                    this.indNotificationTemplateDetail = data;
                    this.notificationEditForm = this._fbnotification.group({
                        header: new FormControl(this.replaceTemplateHeader(this.indNotificationTemplateDetail.header)),
                        name: new FormControl(this.indNotificationTemplateDetail.recipients[0].email),
                        scheduled: new FormControl(new Date(this.indNotificationTemplateDetail.scheduled)),
                        recipients: this._fbnotification.group({
                            name: new FormControl(this.indNotificationTemplateDetail.recipients[0].name),
                            email: new FormControl(this.indNotificationTemplateDetail.recipients[0].email)
                        }),
                        content: new FormControl(this.replaceTemplateConstant(this.indNotificationTemplateDetail.content == undefined ? '' : this.indNotificationTemplateDetail.content)),
                    });
                });
        }, 2000);
    }

    /**
     * this function is used to get Customer Notification Template List.
     */
    getInvoiceNotificationTemplateList(public_id: string) {

        this.customerService.getCustomerNotificationTemplateList(this.customer_public_id, this.templateListLimit)
            .subscribe(data => {
                if (data && Array.isArray(data)) {
                    this.InvoiceNotifyTemplateList = data;
                } else {
                    this.InvoiceNotifyTemplateList = [];
                }
            }, error => {
                this.InvoiceNotifyTemplateList = [];
            });
    }//end

    onupdateNotification({ value }: { value: Notification }) {

        value.scheduled = this.scheduleDate;

        this.notificatioService.updateNotification(this.indNotificationTemplateDetail.public_id, value)
            .subscribe((result) => {
                this.router.navigate([`/payout/invoices/${this.invoicePublic_key}/view`]);
            }, error => {
                console.error('Failed while trying to cancel the Notification Details.' + error);
            });
    }

    rejectInvoice() {
        this.spinnerService.show();
        let rejectDescription = this.invoiceRejectForm.controls['description'].value;
        this.payoutService.rejectInvoice(this.invoicePublic_key, rejectDescription).subscribe(result => {
            this.GetIndividualInvoiceDetails();
        },
            error => {
                console.error('Failed while trying to reject the invoice Details.' + error);
            })
    }

    async checkPaymentCodeConfiguration() {
        try {
            const data = await this.customerService.checkPaymentCodeConfiguration(this.customer_public_id);
            this.paymentCodeConfiguration = data;
            if (this.paymentCodeConfiguration.status == 'ACTIVE') {
                this.isPaymentCodeConfiguration = true;
            }
        }
        catch (error) {
            console.error('Failed while trying to get the payment code configuration.' + error.error)
        }
    }

    async getNotificationProperties() {
        if (this.notificationProperties == null) {
            try {
                const data = await this.notificatioService.getNotificationProperties(this.customer_public_id);
                this.commonDataService.setNotificationPropertiesSharedData(data);
                this.notificationProperties = data;
                this.setNotificationProperties();
            }
            catch (error) {
                if (error.status == 404) {
                    this.notificationPropertiesDictionary = this.notificationReportStatus.status;
                  } else {
                    console.error('Failed while trying to get the notification properties.' + error.error)
                  }
            }
        }
        else {
            this.setNotificationProperties();
       }

    }

    setNotificationProperties() {
       this.notificationPropertiesDictionary = this.notificationProperties.values.property_list.status.dictionary;
    }

    statusNameToSpanish(value) {
        if (this.notificationPropertiesDictionary != null) {
            var tempValue = this.notificationPropertiesDictionary.filter(data => data.value == value);
            if (tempValue.length > 0) {
                return tempValue[0].label;
            }
            return "";
        }else{
            return value;
        }
      }

    async getUserRoleStatus() {
        try {
            const data = await this.userService.getUserDetails(localStorage.getItem('userId'));
            this.userDetails = data;
            this.userRole = this.userDetails.role;
            this.userRoleStatus = this.userDetails.status;
        }
        catch (error) {
            console.error('Failed while trying to getUserRoleStatus.' + error)
        }

    }

    async checkThisPageGrants() {
        await this.getUserRoleStatus();
        await this.auth.isKashioGrantsAvailable();
        this.isUpdateAvailable = this.auth.checkGrants('INVOICES', 'UPDATE');
        this.isDeleteAvailable = this.auth.checkGrants('INVOICES', 'DELETE');
        if (localStorage.getItem('application') == 'PAYOUTS' && this.userRole == 'KashIO-OPS' && this.userRoleStatus == 'ACTIVE') {
            this.isRejectAvailable = this.auth.checkGrants('INVOICES', 'REJECT');
        } else {
            this.isRejectAvailable = false;
        }
    }
}
